// Carousels for the first section
var thumbscarousel = new Swiper(".product-page-main-thumbs", {
	slidesPerView: 'auto',
	spaceBetween: 8,
	slidesPerView: 6,
	loop: false,
	freeMode: false,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	slideToClickedSlide: true,
	direction: "horizontal",
	
	breakpoints: {
		992: {
		slidesPerView: 5,
		direction: "vertical",
		spaceBetween: 8,
		noSwiping: true,
		simulateTouch:false,
		allowTouchMove: false
		},	
	}
});

var covercarousel = new Swiper(".product-page-main-cover", {
	slidesPerView: 1,
	spaceBetween: 20,
	loop: false,
	slideToClickedSlide: true,
	navigation: {
		nextEl: ".slider-product-arrow-right",
		prevEl: ".slider-product-arrow-left",
	},
	thumbs: {
		swiper: thumbscarousel,
	},
	breakpoints: {
		992: {
		slidesPerView: 1,
		spaceBetween: 20,
		},	
	}
});

function onSubscriptionVariantChange(variantPrice,variantComparePrice) {
	let newPrice = `$${variantPrice / 100} CAD`;
    let newComparePrice = `$${variantComparePrice / 100} CAD`;
    if(variantComparePrice > variantPrice){
      vprice = newPrice+ '&nbsp;<u>'+newComparePrice+'</u>';
    }else{
      vprice = newPrice;
    }
	$(".product-page-main-price").html(vprice);
}

$(document).ready(function() {

	$('header').removeClass('transparent-menu').addClass('pink-menu');

	$('.product-main-tabs-title [data-target]').on('click', function () {
		var openTab = $(this).attr('data-target');

		$(this).addClass('active').siblings().removeClass('active');
		$(openTab).addClass('product-main-tab-active').siblings().removeClass('product-main-tab-active');
	});

	initSubscriptionForm();

});

function initSubscriptionForm() {
	var subscribe_select = $('#rc_shipping_interval_frequency');
	if(subscribe_select.length>0){
		$('#subscribe-details-selector').html(subscribe_select.html());
	}
}